// extracted by mini-css-extract-plugin
export default {"loffaDashboard":"Dashboard_loffaDashboard__z8fdJ"};